import styled from "styled-components";

const CardTitle = styled("h4")`
  font-weight: 500;
  color: #454545;
  letter-spacing: 0.05em;
  margin-bottom: 0px;
`

export default CardTitle;